import { Apis } from "../../lib/Apis";

export const useUser = () => {
  const getAllUsers = async (setUsersData, offset = 0, limit = 9) => {
    try {
      const response = await Apis.getAllUsers(offset, limit);
      setUsersData(response.data.data);
      return response.data;
    } catch (error) {
      console.error(
        "🚀 ~ file: useHook.js ~ line 64 ~ getAllUsers ~ error",
        error,
      );
      return error;
    }
  };
  const updateUserStatus = async (id, status) => {
    try {
      const requestBody = {
        id,
        status,
      };
      const response = await Apis.updateUSerStatus(requestBody);
      if (response && response.data) {
        return response;
      } else {
        console.error("Invalid response format:", response);
        return null;
      }
    } catch (error) {
      console.error("Error in Hook:", error.message || error);
      return null;
    }
  };
  const searchUsers = async (
    searchQuery,
    emailQuery,
    statusFilter,
    offset = 0,
    limit = 9,
  ) => {
    try {
      const params = {
        offset,
        limit,
      };

      if (statusFilter !== "") {
        params.status = statusFilter === "true" ? true : false;
      }

      if (searchQuery) {
        params.name = searchQuery;
      }

      if (emailQuery) {
        params.email = emailQuery;
      }

      const response = await Apis.searchUsers(params);
      return response.data;
    } catch (error) {
      console.error(
        "🚀 ~ file: useHook.js ~ line 64 ~ searchUsers ~ error",
        error,
      );
      return error;
    }
  };

  return { getAllUsers, updateUserStatus, searchUsers };
};

export const useBankAccount = () => {
  const getAllBankAccounts = async (setBankAccounts) => {
    try {
      const response = await Apis.getBankAccounts();
      setBankAccounts(response.data);
    } catch (error) {
      console.error(error);
    }
  };
  const addBankAccount = async (data) => {
    try {
      const response = await Apis.addBankAccount(data);
      return response;
    } catch (error) {
      console.error(error);
    }
  };
  const deleteBankAccount = async (id) => {
    try {
      const response = await Apis.delteBankAccount(id);
      return response;
    } catch (error) {
      console.error(error);
    }
  };
  const editBankAccountDetails = async (id, data) => {
    try {
      const response = await Apis.updateBankAccount(id, data);
      return response;
    } catch (error) {
      console.error(error);
    }
  };
  return {
    getAllBankAccounts,
    addBankAccount,
    deleteBankAccount,
    editBankAccountDetails,
  };
};

export const useUtm = () => {
  const getUtmLinks = async (setUtmLinks) => {
    try {
      const response = await Apis.getUtmLinks();
      setUtmLinks(response.data?.data || []);
      if (response.status === 200) {
        return response.data?.data || [];
      }
    } catch (error) {
      return [];
    }
  };
  const addUtm = async (data) => {
    try {
      const response = await Apis.createUtm(data);
      if (response.status === 200 || response.status === 201) {
        return response.data;
      }
    } catch (error) {
      return [];
    }
  };
  const updateUtmStatus = async (id, status) => {
    try {
      const response = await Apis.updateUtmStatus(id, status);
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      throw new Error("Failed to update UTM link status.");
    }
  };

  return {
    getUtmLinks,
    addUtm,
    updateUtmStatus,
  };
};
